import { Constantes } from '@/util/Constantes';
import { createStore } from 'vuex'

export default createStore({
  state: {
    usuario: localStorage.getItem('usuario') !== null ? JSON.parse(localStorage.getItem('usuario')) : null,
    tamanioMaximoArchivo: 20, //Tamanio en Megas
    verPaginaMuchasPeticiones: localStorage.getItem('vpmp') !== null ? localStorage.getItem('vpmp') : false,
  },
  mutations: {
    obtenerUsuario(state, payload) {
      state.usuario = payload;
    },
    verPaginaMuchasPeticiones(state, payload) {
      state.verPaginaMuchasPeticiones = payload;
    }
  },
  actions: {
    guardarUsuario({ commit }, payload) {
      const usuarioGuardar = {
        codigo: payload.codigo,
        rol_codigo: payload.rol_codigo,
        nombre_completo: payload.nombre_completo
      };
      commit('obtenerUsuario', usuarioGuardar);
      localStorage.setItem('usuario', JSON.stringify(usuarioGuardar))
    },
    verPaginaMuchasPeticiones({commit}, payload){
      commit('verPaginaMuchasPeticiones', payload)
    }
  },
  getters: {
    usuario(state) {
      return state.usuario
    },
    verPaginaMuchasPeticiones(state) {
      return state.verPaginaMuchasPeticiones
    }
  }
})
